// The name of the page a URL belongs to, for error messages.
//
// WHY: the top-level crash screen used to read "Something went wrong. Please
// refresh the page." — which named nothing, and asked for a gesture the native
// Android app does not have (no address bar, no pull-to-refresh). When
// /takeoff crashed on build e122663 the owner could not tell from the screen
// which page had failed, and in a report "it broke" is not a bug report.
//
// Labels are the sidebar's own labels (App.js's SIDEBAR / DRAWER_NAV). Kept as
// a plain map rather than imported from App.js on purpose: the error boundary
// sits ABOVE App in the tree (src/index.js) and has to keep working when App
// itself is the thing that just threw.
const PAGE_LABELS = {
  '': 'RoofBeam',
  // Field Mode's two screens. ⚠ "Today" and "Schedule" as a person says them —
  // this table is what a crash report names, and "the /today route" is not a
  // sentence anybody can act on.
  today: 'Today', schedule: 'Schedule',
  // The crew's clocked hours, day and week. Named for what a crash report
  // should say, not for the route.
  labor: 'Crew Hours',
  dashboard: 'Dashboard', leads: 'Leads', 'website-leads': 'Website Leads',
  canvassing: 'Canvassing', prospects: 'Prospects', proposals: 'Proposals',
  jobs: 'Jobs', 'storm-tracker': 'Storm Tracker', neighborhoods: 'Neighborhoods',
  map: 'Map View', contacts: 'Contacts', properties: 'Properties',
  takeoff: 'Takeoff', 'metal-jobs': 'Metal Jobs', estimator: 'Estimator',
  catalog: 'Catalog', documents: 'Documents', calendar: 'Calendar',
  todos: 'To-Do', messages: 'Messages', profit: 'Profit Tracker',
  contractors: 'Contractors', commercial: 'Commercial', 'ai-agents': 'AI Agents',
  settings: 'Settings', 'solar-batch': 'Solar Batch', approvals: 'Approvals',
  claims: 'Claims', permits: 'Permits', team: 'Team', research: 'Research', login: 'Sign In',
  os: 'RoofBeam OS',
  crew: 'Crew', rep: 'Sales', manager: 'Manager', 'canvass-home': 'Canvassing',
  // Public token pages — a customer can land on these, so they get customer
  // wording, not internal page names.
  sign: 'the signing page', report: 'the roof report', 'photo-report': 'the photo report',
  'daily-report': 'the daily report', 'wood-report': 'the wood report',
  'storm-report': 'the storm report', supplement: 'the supplement package',
  range: 'the price range', canvass: 'the canvassing page', g: 'the guest page',
  track: 'the job tracker', v: 'the vendor page',
};

// Title-cases an unknown segment ('new-thing' -> 'New Thing') so a route added
// later is still named, never mislabelled as a page it isn't.
function titleCase(seg) {
  return seg.split('-').filter(Boolean).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

// pageLabelFromPath('/jobs/abc/takeoff') -> 'Jobs'
export function pageLabelFromPath(pathname) {
  const seg = String(pathname || '').split('?')[0].split('#')[0].split('/').filter(Boolean)[0] || '';
  if (PAGE_LABELS[seg]) return PAGE_LABELS[seg];
  return seg ? titleCase(seg) : 'RoofBeam';
}

export { PAGE_LABELS };
